import React, { useContext, useEffect, useMemo, useState } from "react";
import "./EhrDetails.css";
import "./Components/SelectedRecordTables/SelectedRecordTables.css";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ExpandLess, ExpandMore, Launch } from "@mui/icons-material";
import * as c from "../../../utils/constants/constants";
import { PatientTable, EncounterTable, OrderTable } from "./Components";
import EhrPopup from "./EhrPopup";

const EhrDetails = (props) => {
    const { setDocumentData, data = {}, duplicateDocumentView } = useContext(DocumentDetailContext);
    const [ehrAccordion, setehrAccordion] = useState(true);
    const [openEhrPopup, setEhrPopup] = useState(false);

    const ehrDetails = useMemo(() => {
        return data?.Entity_Details?.ehrDetails || {};
    }, [data?.Entity_Details?.ehrDetails]);

    const documentLevel = useMemo(() => {
        const { documentLevel } = data?.Entity_Details?.classify || {};
        return documentLevel;
    }, [data.Entity_Details?.classify]);

    useEffect(() => {
        if(openEhrPopup == false) {
            localStorage.removeItem(c.ENC_DATA);
            localStorage.removeItem(c.APP_DATA);
            localStorage.removeItem(c.ORDER_DATA);
        } 
    }, [openEhrPopup])

    const ehrPopupLabel = useMemo(() => {
        const { documentLevel } = data?.Entity_Details?.classify || {};
        if (documentLevel === "Patient" || (data?.Status == c.status.intervention_rqd && !data?.MRN)) return "Patient Info"
        else if (documentLevel === "Encounter") return "Patient Encounters / Appointments";
        else if (documentLevel === "Order") return "Patient Related Orders";
    }, [data]);

    const isKeyPresent = (data, key) => {
        let res = data && Object.values(data).some((val) => val[key])
        return res;
    };

    return <div className="ehr-details">
        <Accordion expanded={ehrAccordion} sx={{ background: "var(--bg-card-primary)" }}>
            <AccordionSummary
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{
                    padding: "0px 16px !important",
                    width: "100%",
                    "> div": {
                        color: "var(--text-primary)"
                    }
                }}
            >
                <div className="ehr-accordion-header" >
                    <div
                        className="id-fetch-button"
                        onClick={() => !duplicateDocumentView && setEhrPopup(true)}
                    >
                        <div>{ehrPopupLabel}</div>
                        <Launch fontSize="small"
                            style={{ paddingLeft: "5px" }} />
                    </div>
                    <div style={{ pointerEvents: "visible", }}>
                        {ehrAccordion ? <ExpandLess onClick={() => setehrAccordion(!ehrAccordion)} />
                            : <ExpandMore onClick={() => setehrAccordion(!ehrAccordion)} />}</div>
                </div>

            </AccordionSummary>
            <AccordionDetails sx={{padding: "0px 15px"}}>
                <div className="ehr-screen-display">
                    {documentLevel == "Patient" && Object.keys(ehrDetails.patient || {})?.length !== 0 && <PatientTable data={ehrDetails.patient} />}
                    {documentLevel == "Encounter" && Object.keys(ehrDetails.encounter || {})?.length !== 0 && <EncounterTable data={ehrDetails.encounter} isKeyPresent={isKeyPresent} />}
                    {documentLevel == "Order" && Object.keys(ehrDetails.order || {})?.length !== 0 && <OrderTable data={ehrDetails.order} isKeyPresent={isKeyPresent} />}
                </div>
            </AccordionDetails>
        </Accordion>
        <EhrPopup 
            openEhrPopup={openEhrPopup}
            setEhrPopup={setEhrPopup}
        />
    </div>
}

export default EhrDetails;